/**
 * Created by vladislav on 20/10/2022
 */

const Customer = function (unit, options, data) {
    UnitComponent.call(this, unit);

    if (cleverapps.config.adminMode || cleverapps.config.editorMode) {
        return;
    }

    this.viewType = data.viewType || Customer.VIEW.EXTENDED_CUSTOMER_VIEW;

    this.stored = {
        rp: options.rp,
        at: options.at,
        ct: options.ct
    };

    Map2d.currentMap.customers.addCustomer(this);
    Map2d.currentMap.customers.on("onRecipesUpdated", this.checkRecipe.bind(this), this);
    Map2d.currentMap.customers.on("onRecipesUpdated", this.onUpdateState.bind(this), this);
    Map2d.currentMap.customers.on("selectedCustomerChanged", this.onUpdateState.bind(this), this);

    if (Map2dLocation.currentLocation.tutorial) {
        Map2dLocation.currentLocation.tutorial.on("showTutorialStep", this.onUpdateStateTutorial.bind(this), this);
        Map2dLocation.currentLocation.tutorial.on("finishTutorial", this.onUpdateStateTutorial.bind(this), this);
    }

    cleverapps.tutorial.on("nextTutorialStep", this.onUpdateStateTutorial.bind(this), this);
    cleverapps.tutorial.on("finishTutorial", this.onUpdateStateTutorial.bind(this), this);

    this.onGetView = function () {};
};

Customer.prototype = Object.create(UnitComponent.prototype);
Customer.prototype.constructor = Customer;

Customer.prototype.restore = function () {
    if (!this.stored) {
        return;
    }

    const options = this.stored;
    delete this.stored;

    const cookingEndTime = cleverapps.expandTime(options.ct, { seconds: true });
    let appearTime = cleverapps.expandTime(options.at, { seconds: true });

    if (appearTime && cleverapps.gameModes.silentCustomers) {
        appearTime -= this.getCooldownDelay();
    }

    const needsFirstRecipe = !options.rp && !cookingEndTime && !appearTime;

    let recipe;

    if (options.rp) {
        recipe = CustomerRecipe.decode(options.rp);
        if (!recipe.ingredients || !recipe.ingredients.length) {
            recipe = undefined;
            cleverapps.throwAsync(`no ingredients for customer recipe ${this.unit.code} ${this.unit.stage} ${options.rp}`);
        } else if (!CustomerRecipe.isAcceptable(this, recipe)) {
            if (cleverapps.meta.selectedLocationId() === "spring26") {
                recipe = undefined;
            }
            cleverapps.throwAsync(`unacceptable customer recipe ${options.rp} for ${this.unit.code} ${this.unit.stage}`);
        }
    }
    if (!recipe && !needsFirstRecipe) {
        recipe = this.chooseFreeRecipe();
    }

    if (recipe && this.unit.prizesCount) {
        this._setState(Customer.STATE_READY, recipe, undefined, undefined, true);
    } else if (recipe && cookingEndTime) {
        this._setState(Customer.STATE_COOKING, recipe, cookingEndTime, undefined, true);
    } else if (recipe && !appearTime) {
        this._setState(Customer.STATE_RECIPE, recipe, undefined, undefined, true);
    } else {
        this._setState(Customer.STATE_EMPTY, undefined, appearTime || Date.now(), needsFirstRecipe, true);
    }
};

Customer.prototype.onPrizeHarvested = function () {
    Map2d.mapEvent(Map2d.EXCHANGE, { affected: this.unit });

    const climbable = this.unit.findComponent(Climbable);
    if (climbable && !this.unit.isLast()) {
        climbable.gotoNextStage();
        return;
    }

    this.reset();
};

Customer.prototype.checkRecipe = function () {
    if (this.getState() === Customer.STATE_RECIPE && !this.recipe.isOrderValid()) {
        this._setState(Customer.STATE_EMPTY, undefined, Date.now());
    }
};

Customer.prototype.onUpdateState = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
};

Customer.prototype.onChangeState = function () {
    if (this.view) {
        this.view.animateStateChange();
    }
};

Customer.prototype.onUpdateStateTutorial = function () {
    if (this.view) {
        this.view.restoreState(true);
    }
    this.updateAdditionalViewVisibility();
};

Customer.prototype.updateAdditionalViewVisibility = function () {
    const tutorial = Map2dLocation.currentLocation.tutorial;
    const step = tutorial && tutorial.step;

    const hidden = tutorial && tutorial.isActive() && !(step && step.keepAdditionalViews) && !tutorial.checkConditions({ unit: this.unit })
        || cleverapps.tutorial.isActive() && !cleverapps.tutorial.checkConditions({ unit: this.unit });
    if (hidden) {
        this.unit.hideAdditionalViews();
    } else {
        this.unit.showAdditionalViews();
    }
};

Customer.prototype.handleClick = function () {
    if (this.getCookingTimeLeft()) {
        cleverapps.focusManager.display({
            focus: "ConfirmSpeedUpWindowCustomer",
            action: function (f) {
                new ConfirmSpeedUpWindow(this.getSpeedUpOptions());
                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this)
        });

        return;
    }

    if (!this.recipe) {
        if (this._getRecipeRequiredUnit()) {
            CustomerHintContent.pointToCustomer(this.unit.code, this._getRecipeRequiredUnit());
        }
        return false;
    }

    this.unit.squeeze();

    if ([Customer.VIEW.EXTENDED_CUSTOMER_VIEW].includes(this.viewType) && cleverapps.focusManager.focus !== "StartQuest") {
        Map2d.currentMap.customers.selectCustomer(this);
        Map2d.mapEvent(Map2d.CLICK_UNIT, { affected: this.unit });
    } else {
        const heroTutorial = this.unit.findComponent(HeroTutorial);
        if (heroTutorial && heroTutorial.isTutorialRunning) {
            return false;
        }
        this.openWindow();
    }

    return true;
};

Customer.prototype.getSpeedUpOptions = function () {
    return {
        timeLeft: this.getCookingTimeLeft(),
        totalDuration: this.getCookingDuration(),
        eventName: cleverapps.EVENTS.SPENT.CUSTOMER,
        callback: () => {
            this.enjoy();
            this.unit.takePrizes();
        }
    };
};

Customer.prototype.openWindow = function () {
    cleverapps.focusManager.display({
        stack: Map2dLocation.currentLocation.tutorial.checkConditions({ unit: this.unit })
                || cleverapps.tutorial.checkConditions({ unit: this.unit }),
        focus: "OrdersWindow",
        action: function (f) {
            new OrdersWindow({
                maker: this
            });
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });
};

Customer.prototype.handlePrizes = function () {
    return this.unit.prizes.waiting;
};

Customer.prototype.showWaiting = function () {
    if (this.getState() === Customer.STATE_EMPTY && Boolean(CustomerRecipe.createRecipeTemplate(this)) && !this.needsFirstRecipe && this.viewType !== Customer.VIEW.ORDERS_WINDOW) {
        this.unit.setPrizes({ waiting: true });
    }
};

Customer.prototype.exchange = function (callback) {
    cleverapps.tutorial.trigger("onCustomerExchange");
    Map2d.mapEvent(Map2d.BEFORE_EXCHANGE, { source: this });

    this.cook(callback);

    this.unit.squeeze();
};

Customer.prototype.collectUnit = function (unit, callback) {
    const view = this.onGetView() || this.view;
    if (view) {
        view.collectUnitAnimation(unit, callback);
        unit.remove(true);
    } else {
        unit.remove();
        callback();
    }
};

Customer.prototype.cook = function (f) {
    if (this.canCook()) {
        if (Map2d.currentMap.customers.isCustomerSelected(this)) {
            Map2d.currentMap.customers.selectCustomer(undefined);
        }

        this._setState(Customer.STATE_COOKING, this.recipe, Date.now() + this.recipe.getCookingDuration());
        Map2d.currentMap.stock.takeIngredients(this.recipe.ingredients, {
            customer: this,
            callback: f
        });
        Map2dLocation.currentLocation.pushes.updateOrders();
    }
};

Customer.prototype.enjoy = function () {
    if (this.getState() === Customer.STATE_COOKING) {
        this._setState(Customer.STATE_READY, this.recipe);

        Map2dLocation.currentLocation.pushes.updateOrders();

        this.checkAndHarvestPrize();

        cleverapps.eventBus.trigger("complete_order");
    }
};

Customer.prototype.checkAndHarvestPrize = function () {
    if (!this.unit.prizesCount) {
        this.onPrizeHarvested();
    }
};

Customer.prototype.reset = function () {
    this._setState(Customer.STATE_EMPTY, undefined, Date.now());
};

Customer.prototype.order = function (recipe) {
    recipe = recipe || this.needsFirstRecipe && this.chooseFreeRecipe(0) || this.chooseFreeRecipe();

    if (recipe) {
        recipe.wasReadyForCooking = false;
        this._setState(Customer.STATE_RECIPE, recipe);
        cleverapps.effects.fire("merge.order.new");
    } else {
        this.unit.setPrizes();
    }
};

Customer.prototype.chooseFreeRecipe = function (recipeIndex) {
    const recipeTemplate = CustomerRecipe.createRecipeTemplate(this, recipeIndex);
    if (recipeTemplate) {
        return new CustomerRecipe(recipeTemplate);
    }
};

Customer.prototype.isEnoughIngredientsForRecipe = function () {
    return Boolean(this.recipe && this.recipe.isEnoughIngredients());
};

Customer.prototype.getCurrentRecipe = function () {
    if (this.getState() === Customer.STATE_RECIPE) {
        return this.recipe;
    }
};

Customer.prototype.getCookingRecipe = function () {
    if (this.getState() === Customer.STATE_COOKING) {
        return this.recipe;
    }
};

Customer.prototype.hasSomeRecipes = function () {
    return Boolean(CustomerRecipe.createRecipeTemplate(this, undefined, true));
};

Customer.prototype._getRecipeRequiredUnit = function () {
    const recipe = CustomerRecipe.createRecipeTemplate(this, undefined, true);
    if (recipe && recipe.requiredUnits) {
        return recipe.requiredUnits.filter((unit) => !cleverapps.unitsLibrary.isOpened(unit))[0];
    }
};

Customer.prototype.save = function (data) {
    if (this.stored) {
        Object.assign(data, this.stored);
        return;
    }

    if (this.recipe) {
        data.rp = CustomerRecipe.encode(this.recipe);
        data.ri = this.recipe.index; // for backward compatability with old format
    }

    if (this.appearTime !== undefined && !this.needsFirstRecipe) {
        data.at = cleverapps.compactTime(this.appearTime, { seconds: true });
    }

    if (this.cookingEndTime !== undefined) {
        data.ct = cleverapps.compactTime(this.cookingEndTime, { seconds: true });
    }
};

Customer.prototype.destructor = function () {
    runCleaners(this);
    clearTimeout(this.timeout);
    clearTimeout(this.showWaitingTimeout);
    Map2d.currentMap.customers.removeCustomer(this);
};

Customer.prototype.getCooldownDelay = function () {
    const unitData = this.unit.getData();
    let cooldownDelay = Customer.COOLDOWN_DELAY.CUSTOMER;
    if (unitData.cooldown && unitData.cooldown[cleverapps.meta.selectedLocationId()]) {
        cooldownDelay = cleverapps.parseInterval(unitData.cooldown[cleverapps.meta.selectedLocationId()]);
    } else if (this.viewType === Customer.VIEW.ORDERS_WINDOW) {
        cooldownDelay = Customer.COOLDOWN_DELAY.ORDERS_WINDOW;
    }

    if (this.needsFirstRecipe && cleverapps.meta.getSelectedLocation().locationConfig.minimalFirstRecipeDelay) {
        cooldownDelay = Customer.FIRST_RECIPE_DELAY;
    }
    return cooldownDelay;
};

Customer.prototype.getCooldownTimeLeft = function () {
    if (!this.appearTime) {
        return 0;
    }

    return Math.max(0, this.appearTime + this.getCooldownDelay() + Customer.REWARD_SPAWN_DELAY - Date.now());
};

Customer.prototype.getCookingTimeLeft = function () {
    if (this.cookingEndTime) {
        return Math.max(0, this.cookingEndTime - Date.now());
    }
    return 0;
};

Customer.prototype.getCookingDuration = function () {
    if (this.cookingEndTime) {
        return this.recipe.getCookingDuration();
    }
    return 0;
};

Customer.prototype.getGuideOptions = function () {
    const guideOptions = this.unit.getData().customer.guide;
    if (guideOptions) {
        return guideOptions[cleverapps.meta.selectedLocationId()] || guideOptions;
    }
};

Customer.prototype.getPriority = function () {
    return this.unit.getData().customer.priority || 0;
};

Customer.prototype.replaceOrderItemsWithCoins = function () {
    if (!this.recipe) {
        return;
    }
    let isReplaced;
    this.recipe.order.forEach((item) => {
        if (item.unit && Map2dLocation.currentLocation.needToReplaceWithCoins(item.unit)) {
            item.unit = Map2dLocation.currentLocation.getUnitReplacer(item.unit);
            isReplaced = true;
        }
    });
    if (isReplaced && this.unit.prizesCount) {
        this.unit.setPrizes(this.recipe.listPrize());
    }
};

Customer.prototype._setState = function (state, recipe, time, needsFirstRecipe, restore) {
    if (cleverapps.config.editorMode) {
        return;
    }

    clearTimeout(this.timeout);
    clearTimeout(this.showWaitingTimeout);
    this.timeout = undefined;

    this.recipe = undefined;
    this.needsFirstRecipe = undefined;
    this.cookingEndTime = undefined;
    this.appearTime = undefined;

    this._state = state;

    switch (state) {
        case Customer.STATE_RECIPE:
            this.unit.setPrizes();
            this.recipe = recipe;

            Map2d.mapEvent(Map2d.RECIPE_NEW, { source: this });

            break;

        case Customer.STATE_COOKING:
            this.unit.setPrizes();
            this.recipe = recipe;
            this.recipe.cookRecipe();
            this.cookingEndTime = time;
            this.timeout = new cleverapps.LongTimeout(this.enjoy.bind(this), this.getCookingTimeLeft());

            break;

        case Customer.STATE_READY:
            this.recipe = recipe;

            this.setRecipePrizes();

            Map2d.mapEvent(Map2d.RECIPE_READY, { source: this });

            break;

        default: {
            this.unit.setPrizes();
            this.needsFirstRecipe = needsFirstRecipe;
            this.appearTime = time;

            this.timeout = new cleverapps.LongTimeout(this.order.bind(this), this.getCooldownTimeLeft());
        }
    }

    this.unit.save();

    if (restore) {
        this.onUpdateState();
    } else {
        this.onChangeState();
    }
    
    if (this.viewType === Customer.VIEW.ORDERS_WINDOW) {
        cleverapps.toolbar.resetByType(ToolbarItem.ORDERS);
    }

    Map2d.currentMap.customers.onUpdateOrder(this);
    Map2d.currentMap.customers.updateMarks();

    clearTimeout(this.showWaitingTimeout);
    this.showWaitingTimeout = new cleverapps.LongTimeout(this.showWaiting.bind(this), Customer.REWARD_SPAWN_DELAY);
};

Customer.prototype.setRecipePrizes = function () {
    const prizes = this.recipe.listPrize(this.unit.prizesCount);
    this.unit.setPrizes(prizes);
};

Customer.prototype.canCook = function () {
    return this.getState() === Customer.STATE_RECIPE && Map2d.currentMap.stock.canTakeIngredients(this.recipe.ingredients);
};

Customer.prototype.getState = function () {
    return this.stored ? Customer.STATE_UNINITIALIZED : this._state;
};

Customer.prototype.setViewType = function (viewType) {
    this.viewType = viewType;
    this.onUpdateState();
};

Customer.prototype.getViewType = function () {
    return this.viewType;
};

Customer.STATE_EMPTY = 0;
Customer.STATE_RECIPE = 1;
Customer.STATE_COOKING = 2;
Customer.STATE_READY = 3;
Customer.STATE_UNINITIALIZED = 4;

Customer.COOLDOWN_DELAY = {
    ORDERS_WINDOW: cleverapps.parseInterval("30 seconds"),
    CUSTOMER: cleverapps.parseInterval("10 seconds")
};

Customer.REWARD_SPAWN_DELAY = 200;

Customer.FIRST_RECIPE_DELAY = 1000;

Customer.VIEW = {
    ORDERS_WINDOW: "ordersWindow",
    EXTENDED_CUSTOMER_VIEW: "extendedCustomerView"
};